import React, { useState, useMemo } from "react";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { useTheme } from "@mui/material/styles";

const ExpandableCodeBlock = ({ code, maxLines = 10 }) => {
  const [expanded, setExpanded] = useState(false);
  const [copied, setCopied] = useState(false);
  const theme = useTheme();

  const safeCode = code || "";
  const codeLines = useMemo(() => safeCode.trim().split("\n"), [safeCode]);
  const isTruncated = codeLines.length > maxLines;
  const displayedCode = expanded ? codeLines : codeLines.slice(0, maxLines);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(safeCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      // console.error("Copy failed", err);
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: theme.palette.background.guideCard,
        color: theme.palette.text.main,
        fontFamily: "monospace",
        fontSize: "small",
        borderRadius: 2,
        p: 2,
        whiteSpace: "pre-wrap",
        overflowX: "auto",
        border: "1px solid #444",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          zIndex: 1,
        }}
      >
        <Tooltip title={copied ? "Copied!" : "Copy to clipboard"} arrow>
          <IconButton
            onClick={handleCopy}
            size="small"
            sx={{ color: theme.palette.accent.main}}
          >
            {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
          </IconButton>
        </Tooltip>
      </Box>

      {/* Code Display */}
      <pre style={{ margin: 0 }}>
        <code>{displayedCode.join("\n")}</code>
      </pre>

      {/* Show More / Less */}
      {isTruncated && (
        <Box mt={1} display="flex" justifyContent="flex-end">
          <Button
            size="small"
            variant="text"
            onClick={() => setExpanded((prev) => !prev)}
            sx={{ color: theme.palette.accent.main , textTransform: "none" }}
          >
            {expanded ? "Show Less" : "Show More"}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ExpandableCodeBlock;
